import EA from '../helpers/init';

export default EA.Methods.listPagination = ($this) => {
    const controlButtons = $this.querySelectorAll('.general-list-pagination-btn.control');
    const totalPages = [...$this.querySelectorAll('.general-list-pagination-btn.page')];

    const current = totalPages.findIndex(el =>
        el.classList.contains('active')
    );

    // reset disabled buttons
    controlButtons[0].classList.remove('disabled');
    controlButtons[1].classList.remove('disabled');

    // set disabled buttons
    if (current === 0) {
        controlButtons[0].classList.add('disabled');
    }

    if (current === totalPages.length - 1) {
        controlButtons[1].classList.add('disabled');
    }

    const delta = 1;

    totalPages.forEach((page, index) => {

        const isFirst = index === 0;
        const isLast = index === totalPages.length - 1;

        const isNearCurrent =
            index >= current - delta &&
            index <= current + delta;

        if (isFirst || isLast || isNearCurrent) {
            page.classList.remove('hidden');
        }
    });

    const visiblePages = totalPages.filter(
        page => !page.classList.contains('hidden')
    );

    visiblePages.forEach((page, index) => {

        const nextPage = visiblePages[index + 1];

        if (!nextPage) return;

        const currentId = Number(page.id);
        const nextId = Number(nextPage.id);

        if (nextId - currentId > 1) {
            console.log('radi');
            
            const dots = document.createElement('span');
            dots.className = 'general-list-pagination-btn dots body-font text-grey';
            dots.textContent = '...';

            page.insertAdjacentElement('afterend', dots);
        }
    });
};
